// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__2Yffb","footer":"style_footer__w3285"};